import { GroupActions } from '@leverege/molten/imagine';
import { Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { getAddendumPDF } from '../../util/Interface';
export default {
  id: 'billing.downloadAddendumPDF',
  name: 'Download All Addendum PDFs',
  layout: {
    sort: 'z.billing.2',
    sectionName: 'Billing Downloads'
  },
  matches: {
    use: ['contextMenu', 'mobileActionBar'],
    client: 'ItemInfoScreen',
    objectType: 'bill'
  },
  prepare: ({
    clientProps
  }) => {
    const {
      actions
    } = clientProps;
    const childActions = actions.child('addendum');
    const addendumActions = new GroupActions({
      match: childActions.match,
      relationship: childActions.relationship,
      queryName: 'totalAddendumAgg'
    });
    return GlobalState.dispatch(addendumActions.search({
      limit: 0,
      aggs: {
        addenda: {
          type: 'stats',
          field: 'data/amount'
        }
      }
    }, {
      ttl: 2000
    }));
  },
  isPrepared: ({
    clientProps
  }) => {
    const {
      actions
    } = clientProps;
    const childActions = actions.child('addendum');
    const addendumActions = new GroupActions({
      match: childActions.match,
      relationship: childActions.relationship,
      queryName: 'totalAddendumAgg'
    });
    return addendumActions.getList(GlobalState.get(), {
      getAll: true
    })?.aggs;
  },
  handles: ({
    clientProps
  }) => {
    const {
      actions
    } = clientProps;
    const childActions = actions.child('addendum');
    const addendumActions = new GroupActions({
      match: childActions.match,
      relationship: childActions.relationship,
      queryName: 'totalAddendumAgg'
    });
    const aggs = addendumActions.getList(GlobalState.get(), {
      getAll: true
    })?.aggs;
    GlobalState.dispatch(addendumActions.search({
      limit: 0,
      aggs: {
        addenda: {
          type: 'stats',
          field: 'data/amount'
        }
      }
    }, {
      ttl: 2000
    }));
    return aggs?.addenda?.count >= 1;
  },
  appearance: () => ({
    name: 'Download All Addendum PDFs'
  }),
  perform: downloadPDF
};
async function downloadPDF({
  context
}) {
  const systemId = context?.clientProps?.item?.systemId;
  const companyId = context?.clientProps?.item?.data?.company?.id;
  const locationId = context?.clientProps?.item?.data?.location?.id;
  const billingId = context?.clientProps?.item?.id;
  const filename = `RecovR Invoice Addendum - ${context?.clientProps?.item?.networkAliases?.['recovr-invoice']?.invoiceId || context?.clientProps?.item?.data?.name}.pdf`; // eslint-disable-line max-len

  try {
    await getAddendumPDF(systemId, companyId, locationId, billingId, filename);
  } catch (err) {
    Toast.error('Error downloading addendum');
  }
}